import { IJsonQueryPolygon } from '../../../../api-models/common/json_query';
import { TTagsManager } from '../../types/tag';
import { getGeoValueByType } from '../../../../JsonQuery';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'geoPolygon' as const;

export const geoPolygonTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const geoPolygons = getGeoValueByType<IJsonQueryPolygon>('polygon')(jsonQuery);

    if (geoPolygons === null) {
      return null;
    }

    return geoPolygons.map(({ name, coordinates }) => ({
      label: name,
      value: createTagValue(ID, coordinates.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => {
    return jsonQuery;
  },
};
